<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { buildMeta } from "~~/utils/meta-builder";
import { smoxyResearchData } from "~~/utils/research";


const isSticky = ref(false)
const sectionheader = ref<any>(null)
const i18n = useI18n();
const router = useRouter()
const route = useRoute()
const research = smoxyResearchData()


//const decimalFormat = new Intl.NumberFormat(i18n.locale.value, {  maximumFractionDigits: 1, minimumFractionDigits: 1  })
const nrFomat =  new Intl.NumberFormat(i18n.locale.value, {  maximumFractionDigits: 2, minimumFractionDigits: 0  })

const successRate = `${nrFomat.format(research.successRate)}%`
const notSmokedFor4Weeks = `${nrFomat.format(research.notSmokedFor4Weeks)}%`
const successRateStrategy = `${nrFomat.format(research.successRateStrategy)}%`
const basedOnUserCount = nrFomat.format(research.users)
const date = new Intl.DateTimeFormat(i18n.locale.value, { year: 'numeric', month: 'long' }).format(research.ts)

useHead(buildMeta({ key:'science',  follow: true, descriptionReplace: {'success_rate': successRate } }))

const advantages = ref([
  {image:"/icon_strategy.svg", color: '#A864FF', title: i18n.t('science.advantages.list.success')},
  {image:"/icon_help.svg", color: '#FE9191', title: i18n.t('science.advantages.list.help')},
  {image:"/icon_bulb.svg", color: '#8EC9FF', title: i18n.t('science.advantages.list.knowlege')},
  {image:"/icon_imagine.svg", color: '#72DEB7', title: i18n.t('science.advantages.list.mood')},
  {image:"/icon_mental.svg", color: '#B2B6FF', title: i18n.t('science.advantages.list.stress')},
  {image:"/icon_motivation.svg", color: '#FD8900', title: i18n.t('science.advantages.list.motivation')},
])

const onIntersect = (hash: string)=>{
  //console.log("1. on intersect:", hash)
  if(route.hash === hash)return;
  console.log("2. on intersect:", hash)
  router.push(hash)
}

const intersect = ref(onIntersect)

onMounted(() => {
  let sticky = sectionheader.value.offsetTop;
  window.onscroll = function() {onScroll()};

  function onScroll(){
    if(sticky === 0 && !isSticky.value){
      sticky = sectionheader.value.offsetTop
      // inital the offsetTop is not calculated correctly...
    }
    if (window.pageYOffset > sticky-4) {
      isSticky.value = true;
    } else {
      isSticky.value = false;
    }
  }
})

onUnmounted(()=>{
  window.onscroll = null;
})

</script>

<template>
  <div>
    <div class="w-full relative">
        <div class="w-full h-full absolute -z-10">
            <div class="header w-full h-full overflow-x-hidden">
              <svg class="absolute right-0" width="688" height="780" viewBox="0 0 688 780" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112467)">
                <circle cx="522.5" cy="257.5" r="278.5" fill="#FFA5A5" fill-opacity="0.79"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112467" x="0" y="-265" width="1045" height="1045" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="122" result="effect1_foregroundBlur_14818_112467"/>
                </filter>
                </defs>
              </svg>

               <svg class="absolute" width="377" height="565" viewBox="0 0 377 565" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112466)">
                <circle cx="9" cy="197" r="194" fill="#B5FBFF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112466" x="-359" y="-171" width="736" height="736" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="87" result="effect1_foregroundBlur_14818_112466"/>
                </filter>
                </defs>
              </svg>

              <svg class="mx-auto" width="1131" height="612" viewBox="0 0 1131 612" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112468)">
                <circle cx="590" cy="22" r="206" fill="#A864FF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112468" x="0" y="-568" width="1180" height="1180" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="192" result="effect1_foregroundBlur_14818_112468"/>
                </filter>
                </defs>
              </svg>

            </div>
        </div>
        <Header theme="light" />
    
        <div class="flex flex-col-reverse lg:flex-row max-w-screen-lg gap-10 px-10 pt-10 mx-auto items-center justify-center">
          
            <div class="flex flex-col text-center lg:text-left flex-1 pb-40">
                <h1 class="text-6xl lg:text-7xl text-[#290B50] font-owners font-bold pb-6 pt-2" v-html="$t('science.headline')"></h1>
                <p class="text-black/75 text-lg font-light">{{$t('science.body')}}</p>
            </div>
            
            <div class="flex mx-auto w-full items-center justify-center flex-1 overflow-x-hidden">
              <svg class="mx-auto mb-20" width="292" height="252" viewBox="0 0 292 252" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.5" d="M0 163.096C0 156.468 5.37258 151.096 12 151.096H70.7432C77.3706 151.096 82.7432 156.468 82.7432 163.096V251.827H0V163.096Z" fill="url(#paint0_linear_14803_112332)"/>
                <path opacity="0.7" d="M104.328 109.133C104.328 102.505 109.701 97.1328 116.328 97.1328H175.072C181.699 97.1328 187.072 102.505 187.072 109.133V251.827H104.328V109.133Z" fill="url(#paint1_linear_14803_112332)"/>
                <path d="M208.657 12C208.657 5.37258 214.029 0 220.657 0H279.4C286.027 0 291.4 5.37258 291.4 12V251.827H208.657V12Z" fill="url(#paint2_linear_14803_112332)"/>
                <defs>
                <linearGradient id="paint0_linear_14803_112332" x1="41.3716" y1="151.096" x2="41.3716" y2="251.827" gradientUnits="userSpaceOnUse">
                <stop stop-color="white"/>
                <stop offset="1" stop-color="white" stop-opacity="0"/>
                </linearGradient>
                <linearGradient id="paint1_linear_14803_112332" x1="145.7" y1="97.1328" x2="145.7" y2="251.827" gradientUnits="userSpaceOnUse">
                <stop stop-color="white"/>
                <stop offset="1" stop-color="white" stop-opacity="0"/>
                </linearGradient>
                <linearGradient id="paint2_linear_14803_112332" x1="250.028" y1="0" x2="250.028" y2="251.827" gradientUnits="userSpaceOnUse">
                <stop stop-color="white"/>
                <stop offset="1" stop-color="white" stop-opacity="0"/>
                </linearGradient>
                </defs>
                </svg>
            </div>
        </div>

    </div> 
    
    <!-- Sub Nav :class="{'sticky-nav': isSticky}" -->
    <div class="w-full -mt-12 mx-auto max-w-screen-lg h-28 px-2 md:px-6 lg:px-0" :class="{'px-0': isSticky}"> 
      <div ref="sectionheader" :class="{'non-sticky-nav': !isSticky, 'sticky-nav': isSticky}" 
      class="z-50 gap-4 md:gap-6 lg:gap-10 tracking-wide text-center text-slate-500 px-4 leading-4 text-base md:text-lg lg:text-2xl w-full bg-white flex flex-row justify-center items-center transition-all duration-500">
        <NuxtLink to="#approach" class="pb-2" :class="{'text-slate-900 font-semibold tracking-normal border-b-2 border-primary-500': $route.hash === '#approach'}" >{{$t('science.approach.title')}}</NuxtLink>
        <NuxtLink to="#research" class="pb-2" :class="{'text-slate-900 font-semibold tracking-normal border-b-2 border-primary-500': $route.hash === '#research'}" >{{$t('science.research.title')}}</NuxtLink>
        <NuxtLink to="#advantages" class="pb-2" :class="{'text-slate-900 font-semibold tracking-normal border-b-2 border-primary-500': $route.hash === '#advantages'}" >{{$t('science.advantages.title')}}</NuxtLink>
      </div>
    </div>
   
    <!-- approach -->
    <Intersection @enter="intersect('#approach')" :threshold=".0" root-margin="0px 100px">
       <div id="approach" class="relative md:max-w-screen-lg mx-auto px-6 lg:px-0 pb-28" >
    
        <h4 class="text-lg pt-20 text-slate-600 mx-auto text-center">{{$t('science.approach.title')}}</h4>
        <h2 class="text-3xl md:text-4xl pt-6 font-gothic  leading-snug text-black/40 text-center mx-auto">{{$t('science.approach.quote')}}</h2>
        <div class="flex flex-col  md:flex-row gap-6 md:gap-10 lg:gap-20 pt-20">
            <div class="bg-[#FFAF51] rounded-xl w-full flex-1 shadow-[#FF5C00]/30 shadow-2xl">
              <img class="mx-auto py-10" src="@/assets/analyse.svg" alt="analyse chart">
            </div>
            <div class="flex-1 w-full flex flex-col justify-center">
               <h3 class="font-bold font-owners text-3xl">{{$t('science.research.headline')}}</h3>
               <p class="text-md mt-4 text-slate-700">{{$t('science.research.body', {'success_rate': successRate })}}</p>
            </div>
           
        </div>
      </div>
    </Intersection>
     
<!-- research -->
    <Intersection @enter="intersect('#research')" :threshold=".0"   >
      
      <div id="research" class="max-w-screen-lg mx-auto px-6 lg:px-0 flex flex-col justify-center  overflow-hidden pb-10">
        <h4 class="text-lg text-slate-600 mx-auto mt-20  mb-10">{{$t('science.research.title')}}</h4>  
        <div class="flex flex-col md:flex-row gap-6 items-center lg:items-start" >
          <div class="flex-1">
            <p class="stats-number">{{Math.floor(research.successRate)}}</p>
            <p class="stats-label">{{$t('science.research.stats.quit_quote', {'value': successRate})}}</p>
          </div>
          <div class="flex-1">
            <p class="stats-number">{{Math.floor(research.notSmokedFor4Weeks)}}</p>
            <p class="stats-label">{{$t('science.research.stats.four_weeks', {'value': notSmokedFor4Weeks})}}</p>
          </div>
          <div class="flex-1">
            <p class="stats-number">{{Math.floor(research.successRateStrategy)}}</p>
            <p class="stats-label">{{$t('science.research.stats.strategy_quote', {'value': successRateStrategy})}}</p>
          </div>
        </div>

        <p class="text-xs text-gray-500 mt-10 text-right max-w-xs ml-auto">
          {{$t('science.research.stats_note', {'user_count': basedOnUserCount, 'month_year': date})}}
        </p>
      </div>
    </Intersection>

      <!-- advantages -->
    <Intersection @enter="intersect('#advantages')" :threshold=".0">
      <div class="bg-amber-50 w-full">
        <div id="advantages" class="pt-20 md:max-w-screen-lg mx-auto px-10 md:px-6 lg:px-0 text-center pb-20" >

        <h4 class="text-lg text-slate-600">{{$t('science.advantages.title')}}</h4>
        <h2 class="text-3xl font-bold font-owners max-w-xl mx-auto text-slate-900">{{$t('science.advantages.headline')}}</h2>
        <p class="text-md text-slate-900 md:max-w-3xl mx-auto mt-4">{{$t('science.advantages.body')}}</p>
        
        <!-- Icons -->
        <div class="grid grid-cols-1 md:grid-cols-3 mt-20 gap-6 w-full text-left">
            <div v-for="item in advantages" class="flex flex-row items-center w-full">
              <img :src="item.image" alt="icon" 
              :style="{'background-color': item.color}" class="h-24 aspect-square p-2 rounded-3xl">
              <p class="font-bold ml-6 text-xl md:text-base">{{item.title}}</p>

           </div> 
        </div>
      </div>
      </div>
      
    </Intersection>
    <Footer />
   
  </div>
</template>

